export default __webpack_public_path__ + "static/media/undraw_Online_collaboration_re_bkpm.8d6def20.svg";